import React from "react";
import { useNavigate } from "react-router-dom";
import LuckydrawItem from "../LuckydrawItem";
import Banners from "../../centerComponent/Banners";
import Pagination from "../../centerComponent/Pagination";
import SubMenu from "../../centerComponent/Submenu";

const LuckydrawContent = ({ luckydraws, limit, offset, rowCount, onBack, onNext }) => {
  const navigate = useNavigate();

  if (!luckydraws.length) {
    return (
      <>
        <section style={{ marginLeft: "25px", marginRight: "25px", paddingTop: "20px", paddingBottom: "20px" }} id="pContent">
          <SubMenu />
          <Banners currentPage="Lucky draw" />
        </section>
        <section id="pComingSoon">
          <p>รอติดตาม Lucky draw เร็ว ๆ นี้</p>
        </section>
      </>
    );
  }

  return (
    <section id="pContent">
      <SubMenu />
      <Banners currentPage="Lucky draw" />

      <div className="bTitle">
        <h2>Lucky Draw</h2>
        <p>ใช้ Point แลกของที่คุณชอบ</p>
      </div>

      <div className="bBtn">
        <a className="btn">รางวัลทั้งหมด</a>
        <a className="btn outline" onClick={() => navigate("/history-luckydraw")}>
          ประวัติการแลก
        </a>
      </div>

      <div className="bGroupItem" data-event="original">
        {luckydraws.map((item, index) => (
          <LuckydrawItem key={`luckydraw-${item.id}-${index}`} item={item} />
        ))}
      </div>

      <Pagination limit={limit} offset={offset} rowCount={rowCount} onBack={onBack} onNext={onNext} />
    </section>
  );
};

export default LuckydrawContent;
